/**
 * Normalizes a promocode from URL query parameters to uppercase.
 * Returns undefined if the promocode is not provided, is empty, or is not a string.
 *
 * @param promoCode - The promocode value from URL query (can be string, string[], boolean, undefined, or null)
 * @returns The uppercase promocode string, or undefined if not provided or not a string
 */
export const normalizePromoCode = (
  promoCode: string | string[] | boolean | undefined | null
): string | undefined => {
  if (typeof promoCode !== 'string' || !promoCode) {
    return undefined;
  }
  return promoCode.toUpperCase();
};

